import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import api from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch {
      toast.error("Falha ao processar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-hero-radial bg-white">
      <div className="max-w-[460px] mx-auto px-5 pt-10">
        <div className="flex justify-center mb-7"><Logo size={40} /></div>
        <Card className="rounded-2xl shadow-sm">
          <CardContent className="p-6">
            {!submitted ? (
              <>
                <h1 className="font-display text-xl font-semibold text-[hsl(var(--primary))]">Recuperar senha</h1>
                <p className="text-sm text-muted-foreground mt-1">
                  Informe o e-mail cadastrado e enviaremos as instruções para redefinir sua senha.
                </p>
                <form onSubmit={submit} className="mt-5 space-y-4">
                  <div className="space-y-1.5">
                    <Label>E-mail</Label>
                    <Input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="voce@exemplo.com"
                      data-testid="forgot-email-input"
                    />
                  </div>
                  <Button type="submit" className="w-full h-11" disabled={loading} data-testid="forgot-submit">
                    {loading ? "Enviando…" : "Enviar instruções"}
                  </Button>
                </form>
              </>
            ) : (
              <div className="text-center py-3">
                <div className="w-14 h-14 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto mb-3">
                  <Mail className="w-7 h-7" />
                </div>
                <h2 className="font-display text-lg font-semibold text-[hsl(var(--primary))]">Verifique sua caixa de entrada</h2>
                <p className="text-sm text-muted-foreground mt-2 max-w-sm mx-auto">
                  Se o e-mail <strong className="text-foreground">{email}</strong> estiver cadastrado, enviamos um link para redefinir sua senha.
                  O link é válido por <strong>2 horas</strong>.
                </p>
                <p className="text-xs text-muted-foreground mt-3">Não recebeu? Verifique a pasta de spam ou tente novamente.</p>
                <div className="mt-5 grid grid-cols-2 gap-2">
                  <Button variant="outline" onClick={() => { setSubmitted(false); setEmail(""); }}>Reenviar</Button>
                  <Button onClick={() => navigate("/login")}>Voltar ao login</Button>
                </div>
              </div>
            )}
            {!submitted && (
              <p className="mt-5 text-sm text-muted-foreground text-center">
                <Link to="/login" className="text-[hsl(var(--accent))] hover:underline">Voltar ao login</Link>
              </p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
